import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import ProtectedRoute from './components/ProtectedRoute.js';
import { DarkModeProvider } from './components/DarkModeContext.js';

import Home from './pages/General/Home.js';
import Login from './pages/General/Login.js';
import Dominio from './pages/General/Dominio.js';
import AttivazioneDominio from './pages/General/AttivazioneDominio.js';
import Test from './pages/General/Test.js';

import DashDev from './pages/Developer/DashDev.js';
import ImpostazioniDev from './pages/Developer/ImpostazioniDev.js';

import DashManager from './pages/Manager/DashManager.js';
import LogManager from './pages/Manager/LogManager.js';
import ImpostazioniManager from './pages/Manager/ImpostazioniManager.js';
import Licenza from './pages/Manager/Licenza.js';
import AziendeManager from './pages/Manager/AziendeManager.js';
import UtentiManager from './pages/Manager/UtentiManager.js';
import MagazzinoManager from './pages/Manager/MagazzinoManager.js';
import ComponentiManager from './pages/Manager/ComponentiManager.js';
import CodiciManager from './pages/Manager/CodiciManager.js';

import DashUtente from './pages/Utente/DashUtente.js';
import ComponentiUtente from './pages/Utente/ComponentiUtente.js';
import CreaComponenteUtente from './pages/Utente/CreaComponenteUtente.js';
import ProfiloUtente from './pages/Utente/ProfiloUtente.js';
import ScanUtente from './pages/Utente/ScanUtente.js';
import FotoUtente from './pages/Utente/FotoUtente.js';

import DashVenditore from './pages/Venditore/DashVenditore.js';
import CodiciVenditore from './pages/Venditore/CodiciVenditore.js';

function App() {

    // useEffect(() => {
    //     if (window.Worker) {
    //         console.log("1");
    //         Notification.requestPermission().then(permission => {
    //             console.log("2");
    //             if (permission === "granted") {
    //                 const wrk = new Worker(`/Worker.js`);
    //                 wrk.postMessage('start');


    //                 wrk.onmessage = (event) => {
    //                     const { status, data, error } = event.data;

    //                     if (status === 'success') {
    //                         // console.log(data);
    //                         sendNotification(data);
    //                     }
    //                     else {
    //                         console.error('Error fetching data from the worker', error);
    //                     }
    //                 };
    //             } else {
    //                 console.log("Notifiche non permesse");
    //             }
    //         });
    //     }
    // }, []);

    // const sendNotification = async (data) => {
    //     try {
    //         if (Notification.permission === "granted") {
    //             new Notification("Titolo", { body: data });
    //         } else if (Notification.permission !== "denied") {
    //             Notification.requestPermission().then((permission) => {
    //                 if (permission === "granted") {
    //                     new Notification("Titolo", { body: data });
    //                 }
    //             });
    //         }


    //     } catch (error) {
    //         console.error('Error sending the push notification', error);
    //     }
    // };

    return (
        <DarkModeProvider>
            <BrowserRouter>
                <Routes>
                    <Route
                        exact
                        path="/"
                        element={<Home />}
                    />
                    <Route
                        exact
                        path="/login"
                        element={<Login />}
                    />
                    <Route
                        exact
                        path="/dominio"
                        element={<Dominio />}
                    />
                    <Route
                        exact
                        path="/dominio/attivazione"
                        element={<AttivazioneDominio />}
                    />
                    <Route
                        exact
                        path="/test"
                        element={<Test />}
                    />

                    <Route
                        exact
                        path="/dashDev"
                        element={
                            <ProtectedRoute checks={['tokenDev']}>
                                <DashDev />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        exact
                        path="/dashDev/impostazioni"
                        element={
                            <ProtectedRoute checks={['tokenDev']}>
                                <ImpostazioniDev />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        exact
                        path="/dashManager"
                        element={
                            <ProtectedRoute checks={['tokenManager']}>
                                <DashManager />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        exact
                        path="/dashManager/log"
                        element={
                            <ProtectedRoute checks={['tokenManager']}>
                                <LogManager />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        exact
                        path="/dashManager/impostazioni"
                        element={
                            <ProtectedRoute checks={['tokenManager']}>
                                <ImpostazioniManager />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        exact
                        path="/dashManager/impostazioni/licenza"
                        element={
                            <ProtectedRoute checks={['tokenManager']}>
                                <Licenza />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        exact
                        path="/dashManager/aziende"
                        element={
                            <ProtectedRoute checks={['tokenManager']}>
                                <AziendeManager />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        exact
                        path="/dashManager/utenti"
                        element={
                            <ProtectedRoute checks={['tokenManager']}>
                                <UtentiManager />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        exact
                        path="/dashManager/magazzino"
                        element={
                            <ProtectedRoute checks={['tokenManager']}>
                                <MagazzinoManager />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        exact
                        path="/dashManager/componenti"
                        element={
                            <ProtectedRoute checks={['tokenManager']}>
                                <ComponentiManager />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        exact
                        path="/dashManager/codici"
                        element={
                            <ProtectedRoute checks={['tokenManager']}>
                                <CodiciManager />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        exact
                        path="/dashUtente"
                        element={
                            <ProtectedRoute checks={['tokenUser']}>
                                <DashUtente />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        exact
                        path="/dashUtente/componenti"
                        element={
                            <ProtectedRoute checks={['tokenUser']}>
                                <ComponentiUtente />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        exact
                        path="/dashUtente/componenti/creaComponente"
                        element={
                            <ProtectedRoute checks={['tokenUser']}>
                                <CreaComponenteUtente />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        exact
                        path="/dashUtente/profilo"
                        element={
                            <ProtectedRoute checks={['tokenUser']}>
                                <ProfiloUtente />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        exact
                        path="/dashUtente/scan"
                        element={
                            <ProtectedRoute checks={['tokenUser']}>
                                <ScanUtente />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        exact
                        path="/dashUtente/foto"
                        element={
                            <ProtectedRoute checks={['tokenUser']}>
                                <FotoUtente />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        exact
                        path="/dashVenditore"
                        element={
                            <ProtectedRoute checks={['tokenVenditore']}>
                                <DashVenditore />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        exact
                        path="/dashVenditore/codici"
                        element={
                            <ProtectedRoute checks={['tokenVenditore']}>
                                <CodiciVenditore />
                            </ProtectedRoute>
                        }
                    />
                </Routes>
            </BrowserRouter>
        </DarkModeProvider>
    );
}

export default App;
